import React, { useEffect, useState } from "react";
import {
  Card,
  CardActionArea,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { DateTime } from "luxon";
import EventSeatIcon from "@mui/icons-material/EventSeat";
import style from "./ListCard.module.css";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import AssignmentIcon from "@mui/icons-material/Assignment";
import RecordVoiceOverIcon from "@mui/icons-material/RecordVoiceOver";
import useIsAdmin from "../../../hooks/useIsAdmin";

const ListCard = ({ workshop, select }) => {
  const navigate = useNavigate();
  const isAdmin = useIsAdmin();
  const [selected, setSelected] = useState(false);
  const selectedWorkshop = useSelector(
    (state) => state.workshops.selectedWorkshop
  );

  //set the selected workshop card colour
  useEffect(() => {
    selectedWorkshop?.workshopId === workshop.workshopId
      ? setSelected(true)
      : setSelected(false);
  }, [selectedWorkshop]);

  return (
    <>
      {workshop && (
        <Box
          sx={{
            backgroundColor: selected
              ? "list.selected.accent"
              : "list.notSelected.accent",
            borderRadius: "0 0 6px 6px",
            marginRight: "0.25rem",
          }}
        >
          <Card
            sx={{
              my: 0.5,
              backgroundColor: selected
                ? "list.selected.main"
                : "list.notSelected.main",
              "& .MuiCardContent-root": { padding: "0.35rem" },
            }}
            variant="outlined"
          >
            <CardActionArea onClick={() => select(workshop.workshopId)}>
              <CardContent>
                <Typography variant="h6">{workshop.title}</Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box>
                    <Typography variant="body2">
                      {DateTime.fromISO(workshop.startDatetime).toLocaleString(
                        DateTime.DATETIME_MED_WITH_WEEKDAY
                      )}
                    </Typography>
                    {/* <Chip label={workshop.category.name} size="small" /> */}
                  </Box>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              margin: "0 0.25rem",
              gap: "0.25rem",
            }}
          >
            {DateTime.fromISO(workshop.registrationStartDate) <=
              DateTime.now() &&
              DateTime.fromISO(workshop.registrationEndDate) >=
                DateTime.now() && (
                <Tooltip title="Currently during registration period">
                  <AssignmentIcon fontSize="small" color="primary" />
                </Tooltip>
              )}
            {DateTime.fromISO(workshop.startDatetime) <= DateTime.now() &&
              DateTime.fromISO(workshop.endDatetime) >= DateTime.now() && (
                <Tooltip title="Workshop in progress">
                  <RecordVoiceOverIcon fontSize="small" color="warning" />
                </Tooltip>
              )}
            <Chip
              label={workshop.category.name}
              size="small"
              variant="outlined"
              sx={{
                flexGrow: "0.8",
                backgroundColor: "white",
                marginRight: "auto",
              }}
            />
            {isAdmin && (
              <Tooltip title={`Edit this workshop`}>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`edit/${workshop.workshopId}`);
                  }}
                  color="secondary"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title={`View registration list`}>
              <Chip
                label={`${workshop?.seats?.numberRegistered}/${workshop?.seats?.capacity}`}
                icon={<EventSeatIcon />}
                sx={{ display: "flex" }}
                size="small"
                // variant="outlined"
                color={
                  workshop?.seats?.numberRegistered >= workshop?.seats?.capacity
                    ? "warning"
                    : "secondary"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`reg/${workshop.workshopId}`);
                }}
              />
            </Tooltip>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ListCard;
